import { FC } from 'react';
import {
  FilterSection,
  ColumnDateFilter,
  ColumnMultiSelectFilter,
} from 'components/data-table';
import type { TaxScenarioFacets } from './types';
import styles from './tax-scenarios-filters.module.scss';

interface TaxScenariosFiltersProps {
  facets: TaxScenarioFacets | undefined;
}

const toOptions = (items: { id: string; value: string }[] | undefined) =>
  (items ?? []).map((item) => ({ value: item.id, label: item.value }));

/**
 * Filter sidebar for the Tax Scenario list page.
 * @param {TaxScenariosFiltersProps} props - The component props
 * @return {JSX.Element} The filter sidebar
 */
const TaxScenariosFilters: FC<TaxScenariosFiltersProps> = ({ facets }) => {
  return (
    <div className={styles.filtersWrapper}>
      <FilterSection title="Date Filters">
        <ColumnDateFilter columnId="effectiveDate" label="Effective Date" />
        <ColumnDateFilter columnId="createdAt" label="Created At" />
        <ColumnDateFilter columnId="updatedAt" label="Updated At" />
      </FilterSection>

      <FilterSection title="Details">
        <ColumnMultiSelectFilter
          columnId="createdBy"
          label="Created By"
          options={toOptions(facets?.createdByOptions)}
        />
      </FilterSection>
    </div>
  );
};

export { TaxScenariosFilters };
